import React from 'react'
import { Redirect } from 'components/common'

const Index = () => <Redirect path="/pbx-admin/pbx/numbers" />

export default Index
